<script>import { trackComponent } from "@sentry/svelte";
trackComponent({ "trackInit": true, "trackUpdates": true, "componentName": "RegistrationForm" });
import Form from "../../../../components/form/Form.svelte";
import { Paragraph } from "../../../../typography/index.js";
import { createEventDispatcher } from "svelte";
import { AUTHENTICATION } from "../../services/store.js";
import * as API from "../../services/api.js";
let FormElement = null;
const dispatch = createEventDispatcher();
let error = "";
const getData = (store) => ({
    organization: {
        domain: store.domain,
        // @ts-expect-error - TODO: Fix Pegasus Types
        name: store.companyName,
        url: store.url
    },
    user: {
        email: store.email,
        mobile: store.mobile,
        name: store.name
    }
});
const onSubmit = async () => {
    const RESPONSE = await API.register(getData($AUTHENTICATION));
    if ("error" in RESPONSE) {
        ({ error } = RESPONSE);
        return;
    }
    dispatch("success");
};
export const submit = async () => {
    if (FormElement === null) {
        return;
    }
    await FormElement.submit();
};
export const isValid = () => {
    if (FormElement === null) {
        return false;
    }
    return FormElement.isValid();
};
</script>

<Form { onSubmit } { error } id = 'registration' bind:this = { FormElement }>

    {#if Boolean(error)}
        <Paragraph label = { error } css = 'mt-4' color = 'error' />
    {/if}

    <slot>Hello World!</slot>

</Form>